import { api } from './apiClient';

/**
 * For You Dashboard Configuration — `/api/v1/admin/for-you-dashboard-config`
 * Contract: docs/for-you-dashboard/FOR_YOU_DASHBOARD_ADMIN_INTEGRATION.md
 */

const BASE = '/api/v1/admin/for-you-dashboard-config';

export const formatForYouDashboardError = (error, fallback = 'Request failed') => {
  const data = error?.response?.data;
  if (!data) {
    if (error?.request) {
      return 'Unable to reach the server. Please check your internet connection or try again later.';
    }
    return error?.message || fallback;
  }
  if (Array.isArray(data.errors) && data.errors.length) {
    const head = data.message || 'Validation failed';
    return [head, ...data.errors].join('\n');
  }
  if (typeof data.errors === 'string' && data.errors) {
    return data.message && data.message !== data.errors
      ? `${data.message}\n${data.errors}`
      : data.errors;
  }
  return data.message || fallback;
};

const request = async (fn, fallback) => {
  try {
    const response = await fn();
    return response.data;
  } catch (error) {
    const err = new Error(formatForYouDashboardError(error, fallback));
    err.payload = error?.response?.data;
    err.status = error?.response?.status;
    throw err;
  }
};

/**
 * GET singleton config.
 * Returns { exists: false, data: null } on 404 (not created yet).
 * Throws on other errors.
 */
export const getForYouDashboardConfig = async () => {
  try {
    const response = await api.get(BASE);
    return { exists: true, data: response.data?.data ?? response.data };
  } catch (error) {
    if (error?.response?.status === 404) {
      return { exists: false, data: null };
    }
    const err = new Error(
      formatForYouDashboardError(error, 'Failed to load For You dashboard configuration')
    );
    err.payload = error?.response?.data;
    err.status = error?.response?.status;
    throw err;
  }
};

/** PUT create or update singleton */
export const putForYouDashboardConfig = async (payload) =>
  request(
    () => api.put(BASE, payload),
    'Failed to save For You dashboard configuration'
  );

/** POST dry-run validate (no write) */
export const validateForYouDashboardConfig = async (payload) =>
  request(
    () => api.post(`${BASE}/validate`, payload),
    'Failed to validate For You dashboard configuration'
  );
